const headerData = [{
		types: "selection",
		columnwidth: 50,
	},
	{
		prop: "CusCode",
		label: "经销商编号",
		columnwidth: 130,
	},
	{
		prop: "CusName",
		label: "经销商名称",
	},
	{
		prop: "Year",
		label: "年份",
		columnwidth: 100,
	},
	{
		prop: "InvClassName",
		label: "产品线",
	},
	{
		prop: "Score",
		label: "评分",
		columnwidth: 100,
	},
	{
		prop: "CreatorName",
		label: "创建人",
	},
	{
		prop: "CreateTime",
		label: "创建时间",
	}
];
export default headerData;
